export default {
      id: "download-video-2-usage",
      viewBox: "0 0 37 23",
      url: __webpack_public_path__ + "img/icons.svg#download-video-2",
      toString: function () {
        return this.url;
      }
    }